// eslint-disable-next-line import/no-anonymous-default-export
export default {
    baseURLREPORT: "https://e26bmbbxf1.execute-api.us-east-1.amazonaws.com",
    URL_SAT:"https://sfcwwjm12j.execute-api.us-east-1.amazonaws.com",
    URL_FINANCE: "https://txovacyaz8.execute-api.us-east-1.amazonaws.com",
    URL_BANKS: "https://kuga4fp3j9.execute-api.us-east-1.amazonaws.com",
    URL_CONFIGURATION: "https://kelm5b17lg.execute-api.us-east-1.amazonaws.com",
    URL_ASSETS: "https://354iapy5c3.execute-api.us-east-1.amazonaws.com",
    URL_EXPENSES: "https://s7ppqwu1ig.execute-api.us-east-1.amazonaws.com",
    URL_INVENTORY: "https://z4k5obtn7a.execute-api.us-east-1.amazonaws.com",
    URL_REPORTS: "https://uv596wksra.execute-api.us-east-1.amazonaws.com",
    URL_COLLABORATORS: "https://x7xd2jvyqa.execute-api.us-east-1.amazonaws.com",
    URL_BUSINESS_PARTNERS: "https://jsgiefp9f6.execute-api.us-east-1.amazonaws.com",
    URL_EMPLOYEES: "https://x7xd2jvyqa.execute-api.us-east-1.amazonaws.com",
    URL_OPERATIONS_UNILEVER: "https://4bz4vd5aae.execute-api.us-east-1.amazonaws.com",
    URL_INVOICES: "https://9swik8i70a.execute-api.us-east-1.amazonaws.com",
    URL_SUPPORT:"https://os9zgx7w8d.execute-api.us-east-1.amazonaws.com",
    URL_PURCHASE:"https://zv901ycwfj.execute-api.us-east-1.amazonaws.com",

}



